export default __webpack_public_path__ + "static/banner-features-a8534e3c500bd29b93c91dcc9c610655.webp";